import PropTypes from 'prop-types';
import { isEmpty } from 'ramda';
import React from 'react';
import Loader from '../../components/Loader';
import { shopShape } from '../../shapes';
import { getShopAllowBookWithAnyBarber } from '../selectors';
import { SHOP_TYPE } from '../../constants';
import { generateUrlString } from '../../utils/helpers';
import Shop from './Shop';
import config from '../../../config';

const getUrlPattern = (shop) => {
  if (shop.kind === SHOP_TYPE.commision || getShopAllowBookWithAnyBarber(shop)) {
    return config.urlPatterns.booking;
  }
  return config.urlPatterns.barber;
};

const LoadingState = () => (
  <div className="layout u-mt+">
    <Loader />;
  </div>
);

const ShopList = ({ shops, shopIds, isLoading }) => {
  if (isLoading) return <LoadingState />;
  if (isEmpty(shops)) return null;

  const shopMap = shops.reduce((acc, shop) => {
    acc[shop.id] = shop;
    return acc;
  }, {});
  const sortedShops = shopIds.reduce((acc, id) => {
    const shop = shopMap[id];
    if (shopMap[id]) {
      acc.push(shop);
    }
    return acc;
  }, []);
  const list = isEmpty(sortedShops) ? shops : sortedShops;

  return (
    <div className="layout u-mt+ u-flex u-flex-wrap u-justify-content-center">
      {list.map((shop) => {
        const url = generateUrlString(
          { shopRoute: shop.route },
          getUrlPattern(shop)
        );
        return (
          <div
            key={shop.id}
            className="layout__item u-1/2-medium-and-up u-1/3-extralarge-and-up"
          >
            <Shop shop={shop} url={url} />
          </div>
        );
      })}
    </div>
  );
};
ShopList.propTypes = {
  shops: PropTypes.arrayOf(shopShape),
  shopIds: PropTypes.arrayOf(PropTypes.string),
  isLoading: PropTypes.bool,
};
ShopList.defaultProps = {
  shops: [],
  shopIds: [],
  isLoading: false,
};

export default ShopList;



// WEBPACK FOOTER //
// ./src/app/shops/components/ShopList.jsx